import { PureComponent, PropsWithChildren } from "react";

export default class SpellsFilterAdvancedFilterOptions extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-spells-filter__adv-filter-options">
        {this.props.children}
      </div>
    );
  }
}
